import React from "react";
import "./custom2.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom6() {
    return(
        <a className="customContainer" href="/custom7">
            <div className="liliesBorder">
                <img src="./images/liliesBorder.jpg" className="liliesBorderImage" alt="Decoration" />
            </div>
            <div className="slideContainer" id="slide2">
                <div className="stepContainer">
                    <span className="stepBox"></span>
                    <span className="stepText">
                        Artistic progress
                    </span>
                    <span className="arrowFloat">
                        <img className="rightArrow" src="./images/misc/arrowright2.gif" alt="cue to click for next slide."></img>
                    </span>
                </div>
            </div>
            <div className="instructions">
                <div className="instructionText">
                    As I am creating your artwork, I usually send progress photos by email every 2 or 3 days. My clients always enjoy this part. But, it also serves a purpose... If there is something that doesn't look quite right, you can mention it and I will make adjustments. It is easier to do it at that point, than when I am further along. This ensures you get exactly what you want.
                </div>
                <img className="instructionImage" src="./images/commission/progressReport.jpg" alt="examples of photos submitted for quote."></img>
            </div>
        </a>
    );
};


export default Custom6